import React from "react";
import PositionEditorModal from "@/appComponents/Blocks/Modals/RecordEditorModal/PositionEditorModal";
import { useTableManagerContext } from "@/providers/AppendTableProvider";
import { useChartSettingsContext } from "@/providers/ChartSettingsProvider";

export const AppendTablePositionEditorModal = () => {
  const {
    recordEditorContextValue: {
      theData,
      showPositionEditor,
      onSaveRecordEdit,
      onClosePositionEditor
    },
    tableManager
  } = useTableManagerContext();
  const { chartConfigRef } = useChartSettingsContext();

  if (!showPositionEditor || !tableManager.state) return null;

  const queryChartId = chartConfigRef.current?.ID || null;

  return (
    <PositionEditorModal
      theData={theData}
      showPositionEditor={showPositionEditor}
      onSaveRecordEdit={onSaveRecordEdit}
      onClosePositionEditor={onClosePositionEditor}
      manager={tableManager.state}
      queryChartId={queryChartId}
    />
  );
};
